<template>
  <div class="certs">
    <div class="container">
      <h2 class="center">Certifications</h2>
      <r-grid columns="6" columns-l="9" columns-s="3">
        <r-cell span="3" span-s="row">
          <div class="certification">
            <r-grid columns="4">
              <r-cell span="3">
                <h5>
                  <strong> {{ pastureForLife() }}</strong>
                </h5>
                <p>
                  <a class="link-red" href="http://pastureforlife.org"
                    >www.pastureforlife.org</a
                  >
                </p>
              </r-cell>
              <r-cell span="1">
                <div class="cert-logo">
                  <span class="pfla-logo"></span>
                </div>
              </r-cell>
              <r-cell span="row">
                <p>
                  The Pasture-Fed Livestock Association created the Pasture for
                  Life mark which certifies that meat and dairy comes from
                  animals raised only on grass and pasture. The PFLA is the only
                  UK certification body for 100% grass-fed - so unless a
                  producer is approved by the PFLA then there is no guarantee
                  that their produce is not fed grains.
                </p>
              </r-cell>
            </r-grid>
          </div>
        </r-cell>

        <r-cell span="3" span-s="row">
          <div class="certification">
            <r-grid columns="4">
              <r-cell span="3">
                <h5>
                  <strong> {{ demeterBiodynamic() }}</strong>
                </h5>
                <p>
                  <a class="link-red" href="https://www.biodynamic.org.uk/"
                    >www.biodynamic.org.uk</a
                  >
                </p>
              </r-cell>
              <r-cell span="1">
                <div class="cert-logo">
                  <span class="demeter-logo"></span>
                </div>
              </r-cell>
              <r-cell span="row">
                <p>
                  Demeter is the international certification mark for Biodynamic
                  agriculture. Biodynamic is a regenerative form of agriculture
                  that goes beyond organic, sees the farm as a self-sustaining
                  organism and therefore highly values the fertilising elements
                  that ruminants bring to that ecosystem. Meat from a Demeter
                  certified farm is pasture fed, free roaming, has a positive
                  carbon footprint.
                </p>
              </r-cell>
            </r-grid>
          </div>
        </r-cell>

        <r-cell span="3" span-s="row">
          <div class="certification">
            <r-grid columns="4">
              <r-cell span="3">
                <h5>
                  <strong>{{ organic() }}</strong>
                </h5>
                <p>
                  <a class="link-red" href="https://soilassociation.org/"
                    >www.soilassociation.org</a
                  >
                </p>
              </r-cell>
              <r-cell span="1" span-s="1">
                <div class="cert-logo">
                  <span class="organic-logo"></span>
                </div>
              </r-cell>
              <r-cell span="row">
                <p>
                  Soil Association Certification is the UK’s leading organic
                  certification body – certifying over 70% of the growing
                  organic market and responsible for certifying over 3,500 farms
                  and organic businesses all over the world. Organic is the only
                  system of farming that bans the use of artificial pesticides, fertilisers, and hormones as well as the routine use of
                  antibiotics.
                </p>
              </r-cell>
            </r-grid>
          </div>
        </r-cell>

        <r-cell span="3" span-s="row">
          <div class="certification">
            <r-grid columns="4">
              <r-cell span="3">
                <h5>
                  <strong>{{ redTractor() }}</strong>
                </h5>
                <p>
                  <a class="link-red" href="https://redtractor.org.uk/"
                    >www.redtractor.org.uk</a
                  >
                </p>
              </r-cell>
              <r-cell span="1" span-s="1">
                <div class="cert-logo">
                  <span class="red-tractor-logo"></span>
                </div>
              </r-cell>
              <r-cell span="row">
                <p>
                  The Red Tractor logo is a simple way for people to recognise
                  food and drink that has been produced to high quality
                  standards across the whole length of the food chain – from
                  farm to pack. We make sure that food is traceable, safe and
                  farmed with care – so everyone can feel confident and good
                  about their choices when shopping and eating out.
                </p>
              </r-cell>
            </r-grid>
          </div>
        </r-cell>

        <r-cell span="3" span-s="row">
          <div class="certification">
            <r-grid columns="4">
              <r-cell span="3">
                <h5>
                  <strong>{{ qualityStandardMark() }}</strong>
                </h5>
                <p>
                  <a
                    class="link-red"
                    href="https://ahdb.org.uk/trade/what-is-the-quality-standard-mark"
                    >www.ahdb.org.uk</a
                  >
                </p>
              </r-cell>
              <r-cell span="1" span-s="1">
                <div class="cert-logo">
                  <span class="qsm-logo"></span>
                </div>
              </r-cell>
              <r-cell span="row">
                <p>
                  The Quality Standard for beef and lamb is the only scheme in
                  the UK to cover eating quality. All beef and lamb carrying the
                  Mark is chosen according to a strict selection process to
                  ensure it is succulent and tender. Quality Standard beef and
                  lamb is produced to higher standards than required by law with
                  a supply chain which is fully assured and independently
                  inspected at every stage from farm to meat counter.
                </p>
              </r-cell>
            </r-grid>
          </div>
        </r-cell>

        <r-cell span="3" span-s="row">
          <div class="certification">
            <r-grid columns="4">
              <r-cell span="3">
                <h5>
                  <strong>{{ rspcaa() }}</strong>
                </h5>
                <p>
                  <a class="link-red" href="https://www.rspcaassured.org.uk/"
                    >www.rspcaassured.org.uk</a
                  >
                </p>
              </r-cell>
              <r-cell span="1" span-s="1">
                <div class="cert-logo">
                  <span class="rspca-logo"></span>
                </div>
              </r-cell>
              <r-cell span="row">
                <p>
                  RSPCA Assured, previously Freedom Food, is the RSPCA’s farm
                  assurance and food labelling scheme. It aims to improve the
                  welfare of animals farmed for our food. RSPCA Assured assesses
                  farms, hauliers and abattoirs to the RSPCA’s strict welfare
                  standards. RSPCA Assured allows free range, organic, indoor
                  and outdoor farms to join its scheme as long as the RSPCA’s
                  welfare standards can be met.
                </p>
              </r-cell>
            </r-grid>
          </div>
        </r-cell>
      </r-grid>
    </div>
  </div>
</template>

<script>
export default {
  name: "Certifications",
  methods: {
    pastureForLife() {
      return "Pasture For Life";
    },
    organic() {
      return "Organic";
    },
    redTractor() {
      return "Red Tractor";
    },
    qualityStandardMark() {
      return "Quality Standard Mark";
    },
    demeterBiodynamic() {
      return "Demeter Biodynamic";
    },
    rspcaa() {
      return "RSPCA Assured";
    }
  }
};
</script>

<style lang="scss">
@import "@/global-styles/variables.scss";

.certification {
  margin: 0 0 $spacing-5;
}

.certs {
  .cert-logo {
    span {
      height: $spacing-9;
      width: $spacing-9;
    }
  }
}
</style>
